// extracted by mini-css-extract-plugin
export default {"name":"ClickedPreBuiltDetails_name__ACzJ1","price":"ClickedPreBuiltDetails_price__tQwdM","specs":"ClickedPreBuiltDetails_specs__SyL87"};